module.exports = __webpack_public_path__ + "static/900_450_crop-bcb4cbc04c71a61fbae117844495f94b.webp";